import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface MemberRequest {
    m_category: number;
    m_name: string;
    m_mobile: string;
    m_email: string;
    m_memo: string;
    m_password: string;
    customer_idx: number | null;
    customer_name: string | undefined;
}

export const usePostMember = (successCallback?: (memberIdx: number) => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (memberData: MemberRequest) => {
            try {
                const response = await axios.post(enum_api_uri.post_member, memberData, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                return response.data.data.member_idx;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: memberIdx => {
            queryClient.invalidateQueries({ queryKey: ["getMemberList"] });
            successCallback?.(memberIdx);
        },
    });
};
